import { DomainGroup, SubDomainGroupBase } from '../../types';
import { DomainEntityPath } from '../../../../../services';
import { AvailableIcons } from '../../../../../components-dummy';
import { RuleGroup } from '../../../../Collections';
import { collectionRulesDiffsSchema } from './collection-rules-diff-schema';

type EntityType = { ruleGroups: RuleGroup[] };

export const collectionRulesDomainGroup: DomainGroup & SubDomainGroupBase<EntityType> = {
  domainKey: DomainEntityPath.CollectionRules,
  title: 'Collection Rules',
  icon: AvailableIcons.Collections,
  getCardTitle: (): string => {
    return `Collections > Collection Rules`;
  },
  fieldsSchema: collectionRulesDiffsSchema,
};
